'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { TextPassage, ImageMagnifer, } from '../../index.js';
import { VerticalImageGalleryPortal } from './VerticalImageGallery.js';
export const ProductImage = (_a) => {
    var { imgSrc, imgAlt, imageComponent, imageComponentProps, instructionText, hoveredImageinstructionText } = _a, rest = __rest(_a, ["imgSrc", "imgAlt", "imageComponent", "imageComponentProps", "instructionText", "hoveredImageinstructionText"]);
    const [isHoveringImage, setIsHoveringImage] = useState(false);
    const renderProductImageText = (text) => text && (_jsx(TextPassage, Object.assign({ align: "center", className: "sparky-c-vertical-product-gallery__instructions" }, { children: text })));
    return (_jsxs("div", Object.assign({ className: "sparky-c-vertical-carrousel__image-container" }, { children: [_jsx(ImageMagnifer, Object.assign({ imgSrc: imgSrc, imgAlt: imgAlt, imageComponent: imageComponent, imageComponentProps: imageComponentProps, handleMagnifierWindowRender: !rest.followMousePosition
                    ? (magnifierWindow) => (_jsx(VerticalImageGalleryPortal, { children: magnifierWindow }))
                    : undefined, handleHoverStart: () => setIsHoveringImage(true), handleHoverEnd: () => setIsHoveringImage(false) }, rest)), !isHoveringImage && renderProductImageText(instructionText), isHoveringImage && renderProductImageText(hoveredImageinstructionText)] })));
};
export default ProductImage;
//# sourceMappingURL=ProductImage.js.map